import { type CSSProperties, useLayoutEffect, useRef } from "react";

export function getDataTablePinningStyle(side: false | "start" | "end", index: number): CSSProperties | undefined {
  return side ? { [side === "start" ? "insetInlineStart" : "insetInlineEnd"]: `var(--data-table-pinned-${side}-${index}, 0px)` } : undefined;
}

/** 用浏览器实际列宽计算偏移，兼容自动布局、响应式隐藏列和内容宽度变化。 */
export function useDataTableColumnPinning(enabled: boolean, layoutKey: string) {
  const tableRef = useRef<HTMLTableElement>(null);

  useLayoutEffect(() => {
    const table = tableRef.current;
    if (!enabled || !table || !layoutKey) return;

    const headers = Array.from(table.tHead?.rows.item(table.tHead.rows.length - 1)?.cells ?? []);
    const updateOffsets = () => {
      // 先完成所有布局读取，再批量写入；滚动时由 CSS sticky 处理，无需监听 scroll。
      const widths = new Map(headers.map((header) => [header, header.getBoundingClientRect().width]));
      for (const side of ["start", "end"] as const) {
        const pinned = headers.filter((header) => header.dataset.pinned === side);
        if (side === "end") pinned.reverse();
        let offset = 0;
        for (const header of pinned) {
          table.style.setProperty(`--data-table-pinned-${side}-${header.dataset.pinnedIndex}`, `${offset}px`);
          offset += widths.get(header) ?? 0;
        }
      }
    };

    updateOffsets();
    const observer = new ResizeObserver(updateOffsets);
    observer.observe(table);
    for (const header of headers) observer.observe(header);
    return () => observer.disconnect();
  }, [enabled, layoutKey]);

  return tableRef;
}
